import { render, staticRenderFns } from "./DocusignEditSignerRole.vue?vue&type=template&id=0559f99c&"
import script from "./DocusignEditSignerRole.vue?vue&type=script&lang=ts&"
export * from "./DocusignEditSignerRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports